module.exports = __webpack_public_path__ + "img/save-gb-whatsapp-status.10daf92c.webp";